import { ModalProps } from 'antd/lib'
import { useState } from 'react'
import { toast } from 'react-toastify'

import { useAddCustomerFileAttachment } from '@/queries/customers/useAddCustomerFileAttachment'
import Button from '@/ui/atoms/Button'
import DraggableFileUpload from '@/ui/atoms/DraggableFileUpload'
import Modal from '@/ui/Modal'
import cn from '@/utils/tailwind/cn'

type Props = {
  isOpen: boolean
  onClose: () => void
  onSave?: (formula: string) => void
  clientId: number
} & ModalProps

function CustomerFileAttachment({
  isOpen,
  onClose,
  onSave,
  className,
  clientId,
  ...props
}: Props) {
  const { addCustomerFileAttachment, isLoading } =
    useAddCustomerFileAttachment()
  const [files, setFiles] = useState<File[]>([])

  async function handleSave() {
    const failedFiles: File[] = []
    const saveFile = async (file: File) => {
      try {
        await addCustomerFileAttachment({
          customer: clientId,
          file: file,
        })
      } catch (error) {
        failedFiles.push(file)
        toast.error(`Failed while adding file attachment: ${file.name}`)
      }
    }

    await Promise.all(files.map(saveFile))
    if (!!failedFiles.length && failedFiles.length !== files.length) {
      toast.warning('Some files failed to add')
    } else if (failedFiles.length === 0) {
      toast.success('File attachments added successfully')
      onClose()
    }
  }

  return (
    <Modal
      {...props}
      className={cn('[&_.ant-modal-footer]:hidden', className)}
      footer={() => undefined}
      onCancel={onClose}
      open={isOpen}
      title={'Add File Attachment'}
    >
      {isOpen ? (
        <div className="flex flex-col gap-4">
          <DraggableFileUpload
            multiple={true}
            onChange={setFiles}
            showUploadList={false}
          />

          <div className="flex justify-end">
            <Button $primary loading={isLoading} onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      ) : null}
    </Modal>
  )
}

export default CustomerFileAttachment
